import React, {useEffect} from "react";
const DicomStart = () => {
    useEffect(() => {
        // Redirect to OHIF index.html that you built into public/ohif
        window.location.href = "/ohif/index.html";
    }, []);
    return <div>Loading OHIF Viewer...</div>;
};
export default DicomStart;
